import advertsActionTypes from './action-types';

export const fetchAdvertsList = payload => ({
  type: advertsActionTypes.FETCH_ADVERTS_LIST,
  payload,
});

export const fetchAdvertsListSuccess = payload => ({
  type: advertsActionTypes.FETCH_ADVERTS_LIST_SUCCESS,
  payload,
});

export const fetchAdvertsListFail = payload => ({
  type: advertsActionTypes.FETCH_ADVERTS_LIST_FAIL,
  payload,
});

export const fetchAddOrEditAdvertSubmission = payload => ({
  type: advertsActionTypes.FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION,
  payload,
});

export const fetchAddOrEditAdvertSubmissionSuccess = payload => ({
  type: advertsActionTypes.FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddOrEditAdvertSubmissionFail = payload => ({
  type: advertsActionTypes.FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_FAIL,
  payload,
});
